<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <p-panel header="{{ 'POLITICAS.LBL_ALERTAS' | translate}}">
    <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioPolitica" name="nomFormularioPolitica" *ngIf="!verDetalle">
      <div class="grid form-group">
        <div class="col-4 md:col-4 lg:col-4">
          <div class="div-form">
            <label>* {{ 'POLITICAS.LBL_POLITICA' | translate }}</label>
            <p-multiSelect id="idPolitica" name="nomDestinos" [options]="lisPolitica" filter="filter"
                           defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                           selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idPolitica"
                           emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           optionValue="value"
                           optionLabel="label"
            ></p-multiSelect>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idPolitica.invalid">
              {{ 'POLITICAS.LBL_POLITICA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>



        <div class="col-4 md:col-4 lg:col-4">
          <div *ngIf="!guardando">
            <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                    type="submit"
                    pButton></button>
          </div>
          <div *ngIf="guardando">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_GUARDANDO' | translate }}</span>
          </div>
        </div>
      </div>
    </form>

    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" [loading]="guardando"
                 [value]="lisProductosPolitica" selectionMode="single" dataKey="idProductoDestino"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.codigoPolitica}}</td>
              <td>{{row.politica}}</td>
              <td>{{row.indicadorPoliticaProducto ? ('POLITICAS.LBL_POLITICAPRODUCTO' | translate) : row.indicadorPoliticaModalidad ? ('POLITICAS.LBL_POLITICAMODALIDAD' | translate) : ('POLITICAS.LBL_POLITICAGLOBAL' | translate) }}</td>
              <td class="text-center" *ngIf="!verDetalle">
                <div class="btn-group" role="group" *ngIf="row.indicadorPoliticaProducto">
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                          title="{{'BTN_INHABILITAR' | translate}}" pButton
                          (click)="inhabilitar(row)" ></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </p-panel>
</div>


<p-confirmDialog #cd key="destinos">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

<p-dialog id="dlgCausales"
          [draggable]="false"
          [resizable]="false"
          [closable]="true"

          *ngIf="detalle"
          [(visible)]="detalle"
          [contentStyle]="{'width':'600px', 'overflow-y': 'auto', 'max-height': '350px', 'overflow-x': 'auto'}"
          [header]="tituloDetalle"
          [modal]="true">

  <div class="grid form-group">
    <div class="col-12 md:col-12 lg:col-12">
      <div class="div-form">
        {{textoDetalle}}
      </div>
    </div>
  </div>
</p-dialog>
